import FeatureFlagsEditor from "./components/feature-flags-editor";
import { FEATURE_FLAGS_DIALOG_ID } from "./constants";

export const FeatureFlagsDialog = Object.assign(FeatureFlagsEditor, {
  dialogId: FEATURE_FLAGS_DIALOG_ID,
});

export { FEATURE_FLAGS_DIALOG_ID };
